// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__13vDt","question":"Question_question__2Q3a8","description":"Question_description___iD-T"};